/* eslint-disable camelcase */
import KeycloakService from '../../../utils/keycloakService'
import { startSxpProxy } from '../../../utils/api'
import { OPD_PROJECT_ID, RADIOLOGY_PROJECT_ID } from '../../../utils/constants'
import {
  RadiologyLabOrder,
  radiologyIntents,
  visit,
  radiologyTestStatus,
  patientText,
  radiologyModes,
  packageLabel,
  tabs,
  patientIdentifier,
  thopIdText,
  genderConstants,
  mobileText,
  registrationConstants,
  observation,
  radiology,
  radiologyText,
  collectionTable,
} from '../Constants/constants'
import {
  RadiologyOrders,
  RadiologyResult,
  radiologyDepartments,
} from '../models'
import { makeName } from '../../lms/utils'
import { getTotalAge } from '../../../utils/dateUtils'
import { Patient } from 'fhir/r4'
import { orderStatus } from '../../lms/constants'
import { getLocationAddress } from '../../patients/utils'
import { toast } from 'react-toastify'
export const saveOrder = (
  mode: 'visit' | 'patient' | undefined,
  order: RadiologyLabOrder,
  id: string,
  patientId: string,
  uhid: string,
  lrNumber: string,
  filteredPanels?: any,
  filteredSamples?: [],
  source?: string,
  packageId?: number,
  price?: number,
  requestedBy?: string,
  origin?: string,
  packageIds?: any,
  combinedResult?: any
) => {
  const intent = order?.id
    ? radiologyIntents?.updateRadiologyOrderById
    : radiologyIntents?.createRadiologyOrder
  const state = {
    radiologyOrderId: order?.id,
    order: order,
    visitId: mode === visit && id ? parseInt(id) : undefined,
    radiologyLabTests: filteredPanels,
    radiologySamples: filteredSamples,
    lrNumber: order?.lr_number ?? lrNumber,
    orderedByName: KeycloakService.getFullname(),
    orderedById: KeycloakService.getSub(),
    patientId: mode === patientText ? id : order?.patient_id ?? patientId,
    patientUhid: uhid ?? order?.patient_uhid ?? undefined,
    status: order?.status ?? radiologyTestStatus?.ordered,
    source: order?.source ?? source ?? undefined,
    packageId: packageId,
    price: price,
    requestedBy: requestedBy,
    origin: origin,
    packageIds: packageIds,
    combinedResult: combinedResult,
  }
  return startSxpProxy(RADIOLOGY_PROJECT_ID, intent, state)
}
export const getDoctorForVisit = (id: string): Promise<string> => {
  const state = { id: id }
  return startSxpProxy(
    OPD_PROJECT_ID,
    radiologyIntents?.getDoctorByVisit,
    state
  )
    .then((doctor) => {
      const { name, qualification } = doctor.data
      return `${name}${qualification ? ` [${qualification}]` : ''}`.trim()
    })
    .catch(() => '')
}
export const TotalPackagePrice = (tests: any[]) => {
  const totalPrice = tests?.reduce((sum, row) => {
    return sum + (row?.packageTests?.price || 0)
  }, 0)
  return totalPrice
}
export const transformData = (data: any, mapped: any) => {
  if (!data?.id) {
    return []
  } else {
    const { package_ids, radiology_order_tests, origin, requested_by } = data
    const radiologyOrderTests = radiology_order_tests?.filter(
      (e: any) => e?.test_status !== radiologyTestStatus?.deleted
    )
    const testModeResults = radiologyOrderTests
      ?.filter((test: any) => test.is_test_select)
      ?.map((test: any) => ({
        mode: { value: 'test', label: 'Test' },
        origin: { value: origin, label: origin },
        requestedBy: { value: requested_by, label: requested_by },
        sampleName: {
          label: test.sample_name,
          value: test.sample_id?.toString(),
        },
        testName: { label: test.test_name, value: test.test_id },
        packageName: null,
        packageTests: null,
      }))

    const packageModeResults = package_ids?.map((packageId: any) => {
      const packageInfo = mapped?.find(
        (pkg: any) => pkg?.packageId === parseInt(packageId)
      )
      const modifiedPackageTests = radiologyOrderTests?.filter((test: any) =>
        test?.package_ids?.includes(packageId)
      )

      return {
        mode: { value: radiologyModes?.package, label: packageLabel },
        origin: { value: origin, label: origin },
        packageName: {
          label: packageInfo?.packageName,
          value: packageInfo?.packageId,
          isDisabled: false,
        },
        packageTests: {
          packageId: packageInfo?.packageId,
          packageName: packageInfo?.packageName,
          price: packageInfo?.price,
          testCount: modifiedPackageTests?.length?.toString(),
          radiology_lab_tests: modifiedPackageTests?.map((test: any) => ({
            testId: test?.test_id,
            sampleId: test?.sample_id?.toString(),
            testName: test?.test_name,
            sampleName: test?.sample_name,
          })),
        },
        requestedBy: { value: requested_by, label: requested_by },
        sampleName: null,
        testName: null,
      }
    })
    const result = [...testModeResults, ...packageModeResults]
    return result
  }
}
export const TestEnteredFilter = (order: RadiologyOrders | null) => {
  if (order) {
    const filteredTests = order?.radiology_test_results?.filter((test: any) => {
      if (test?.test_status === radiologyTestStatus?.entered) {
        const hasValues = test?.values?.summary
        const referredOutWithDocument = test?.referred_out
          ? !!test?.document_url
          : true

        return hasValues && referredOutWithDocument
      }

      return false
    })

    return filteredTests
  }
}
export const TestSubmittedFilter = (order: RadiologyOrders | null) => {
  if (order) {
    const enteredTests = order?.radiology_order_tests?.filter(
      (test: any) => test?.test_status === radiologyTestStatus?.submitted
    )

    return enteredTests
  }
}
export const filteredTabResults = (
  results: RadiologyResult[],
  activeTab: string
) => {
  let statuses: string[]
  switch (activeTab) {
    case tabs?.testing:
      statuses = [
        radiologyTestStatus?.ordered,
        radiologyTestStatus?.orderModified,
        radiologyTestStatus?.entered,
        radiologyTestStatus?.referredEntered,
        radiologyTestStatus?.reOrdered,
      ]
      break
    case tabs?.validation:
      statuses = [radiologyTestStatus?.submitted]
      break
    default:
      statuses = []
  }

  return results?.filter((result) => statuses?.includes(result?.test_status))
}
export const getPatientIdentifierById = (patient: Patient) => {
  const uhid = patient?.identifier?.find(
    (e: any) => e?.system === patientIdentifier
  )?.value
  return uhid ?? ''
}
export const RegistrationType = (regType: string) => {
  switch (regType) {
    case registrationConstants?.fr:
      return registrationConstants?.full
    case registrationConstants?.qr:
      return registrationConstants?.quick
    case registrationConstants?.erShort:
      return registrationConstants?.er
    case registrationConstants?.pmc:
      return registrationConstants?.pharmacy
    case registrationConstants?.labShort:
      return registrationConstants?.lab
    case registrationConstants?.dgs:
      return registrationConstants?.diagnostics
    case registrationConstants?.camp:
      return registrationConstants?.campaign
    case registrationConstants?.membershipShort:
    case registrationConstants?.membershipPrimary:
      return registrationConstants?.membership
    case registrationConstants?.packageshort:
      return registrationConstants?.package
    default:
      return registrationConstants?.other
  }
}
export const mapPatients = async (
  nodes: RadiologyOrders[]
): Promise<RadiologyOrders[]> => {
  try {
    const nodeIds = nodes?.map((n) => n?.patient_id)
    const ids = Array.from(new Set(nodeIds)).join(',')
    const response = await startSxpProxy(
      OPD_PROJECT_ID,
      radiologyIntents?.getPatientsByIdsApi,
      { ids }
    )
    const entry = response?.data?.entry
    if (entry?.length) {
      const patientObj = entry?.reduce(
        (acc: any, cur: any) => ({ ...acc, [cur?.resource?.id]: cur }),
        {}
      )
      return nodes.map((node) => {
        const pat = node.patient_id ? patientObj[node?.patient_id] : null
        const thopId = pat?.resource?.identifier?.[0]?.value ?? thopIdText
        const gender = pat?.resource?.gender
        const assignedGender =
          gender === genderConstants?.male
            ? genderConstants?.capitalMale
            : gender === genderConstants?.female
            ? genderConstants?.capitalFemale
            : genderConstants?.capitalOthers
        const preferredCommunication = pat?.resoucre?.telecom?.find(
          (e: any) => e?.system === 'sms'
        )
        const preferred =
          preferredCommunication?.value === 'yes' ? 'SMS' : 'WHATSAPP'
        return {
          ...node,
          patientThopId: thopId,
          patientUhid:
            pat?.resource?.identifier?.find(
              (e: any) => e?.system === patientIdentifier
            )?.value ?? thopId,
          patientName: makeName(pat?.resource?.name),
          patientGender: assignedGender,
          patientMobile: pat?.resource?.telecom?.find(
            (prt: any) => prt?.use === mobileText
          )?.value,
          patientAge: getTotalAge(
            new Date(pat?.resource?.birthDate ?? new Date())
          ),
          patientCommunication: preferred,
        }
      })
    }
    return nodes
  } catch (er) {
    return nodes
  }
}
export const mappedPatients = async (nodes: any): Promise<any> => {
  try {
    const nodeIds = nodes?.map((n: any) => n?.patient_registered_id)
    const ids = Array.from(new Set(nodeIds)).join(',')
    const response = await startSxpProxy(
      OPD_PROJECT_ID,
      radiologyIntents?.getPatientsByIdsApi,
      { ids }
    )
    const entry = response?.data?.entry
    if (entry?.length) {
      const patientObj = entry?.reduce(
        (acc: any, cur: any) => ({ ...acc, [cur.resource.id]: cur }),
        {}
      )
      return nodes.map((node: any) => {
        const pat = node?.patient_registered_id
          ? patientObj[node?.patient_registered_id]
          : null
        const gender = pat?.resource?.gender
        const assignedGender =
          gender === genderConstants?.male
            ? genderConstants?.capitalMale
            : gender === genderConstants?.female
            ? genderConstants?.capitalFemale
            : genderConstants?.capitalOthers
        return {
          patientName: makeName(pat?.resource?.name),
          patientGender: assignedGender,
          patientMobile: pat?.resource?.telecom?.find(
            (prt: any) => prt?.use === mobileText
          )?.value,
          patientAge: getTotalAge(
            new Date(pat?.resource?.birthDate ?? new Date())
          ),
          id: node?.id,
          bedId: node?.bed_id,
          bedStatus: node?.bed_status,
          patientId: node?.patient_id,
          dateCreated: node?.date_created,
          dateStarted: node?.date_started,
          dateOfDischarge: node?.date_of_discharge,
          bedNumber: node?.bed.bed_number,
          location: node?.bed.location_id,
          patient_registered_id: node?.patient_registered_id,
          assigned_doctor: node?.assigned_doctor,
          doctor_department: node?.doctor_department,
        }
      })
    }
    return nodes
  } catch (er) {
    return nodes
  }
}
export const removeSampleDuplicates = (arr: any) => {
  const filteredArray = arr?.map((e: any) => e?.sample_name)
  return [...new Set(filteredArray)]
}
export const groupByTestName = (data: any) => {
  const grouped: any = {}

  data?.forEach((item: any) => {
    if (!grouped?.[item?.test_name]) {
      grouped[item?.test_name] = []
    }
    grouped?.[item?.test_name]?.push(item)
  })

  return Object.keys(grouped)?.map((testName) => ({
    testName,
    testStatuses: grouped[testName],
  }))
}
export const transformRadiologyResults = (
  radiologyResults: any[],
  radiologyDepartments: any[]
) => {
  return radiologyResults?.map((e: any) => {
    const department = radiologyDepartments?.find(
      (d: any) => d?.id === e?.authorised_by_id
    )

    return {
      Radiology: [
        {
          id: radiologyText,
          interpretation: e?.radiology_lab_test?.Interpretation ?? null,
          name: e?.test_name,
          sample: e?.sample_name ?? '',
          pathologyName: e?.authorised_by_name,
          pathologySignature: department?.siganture || '',
          pathologistQualification: department?.qualification || '',
          pathologyDepartment: department?.code || '',
          resultType: observation,
          technician_name: e?.validated_by,
          tests: [e],
        },
      ],
    }
  })
}

export const radiologyPrintData = (
  data: any,
  patient: Patient | null,
  locationAddress: any,
  radiologyDepartments: radiologyDepartments[]
) => {
  const item = data?.data?.update_radiology_orders_by_pk
  const radiologyResults = item?.radiology_test_results?.filter(
    (e: any) => e?.test_status === orderStatus?.approved
  )
  const refractored = radiologyResults?.map((e: any) => {
    const obj = {
      id: radiology,
      interpretation: e?.radiology_lab_test?.Interpretation ?? null,
      name: e?.test_name,
      sample: e?.sample_name ?? '',
      pathologyName: e?.authorised_by_name,
      pathologySignature:
        radiologyDepartments?.find((d: any) => d?.id === e?.authorised_by_id)
          ?.siganture || '',
      pathologistQualification:
        radiologyDepartments?.find((d: any) => d?.id === e?.authorised_by_id)
          ?.qualification || '',
      pathologyDepartment:
        radiologyDepartments?.find((d: any) => d?.id === e?.authorised_by_id)
          ?.code || '',
      resultType: observation,
      technician_name: e?.validated_by,
      tests: [e],
    }
    return { Radiology: [obj] }
  })

  const obj: any = {
    type: 'radiology',
    id: patient?.id,
    name: makeName(patient?.name),
    age: getTotalAge(new Date(patient?.birthDate ?? new Date())),
    gender:
      patient?.gender === genderConstants?.male
        ? genderConstants?.capitalMale
        : patient?.gender === genderConstants?.female
        ? genderConstants?.capitalFemale
        : genderConstants?.capitalOthers,
    patientAddress: locationAddress,
    mobile: patient?.telecom?.find((prt: any) => prt?.use === mobileText)
      ?.value,
    lrNumber: item?.lr_number ?? '',
    radiologyTests: item?.radiology_order_tests,
    radiologyResults: refractored,
    orderType: item?.origin ?? '',
    orderedOn: item?.ordered_on ?? '',
    invoiceWithHeaderValue: true,
    requestedBy: item?.requested_by ?? item?.ordered_by_name ?? '',
    validatedOn: item?.validation_completed_on ?? '',
    fileId: item?.document_id,
  }

  return obj
}
export const radiologyuploadToDMS = async (
  blobData: Blob,
  patient: any,
  locationAddress: any
) => {
  const name = makeName(patient?.name)
  const mobile = patient?.telecom?.find(
    (prt: any) => prt?.use === mobileText
  )?.value
  try {
    const myHeaders = new Headers()
    myHeaders.append(
      'Authorization',
      `Bearer ${sessionStorage.getItem('react-token')}`
    )

    const formdata = new FormData()
    formdata.append('stateId', '1971')
    formdata.append('preference', 'WHATSAPP')
    formdata.append('sendTo', `91${mobile}`)
    formdata.append('location', `${locationAddress}`)
    formdata.append('name', `${name}`)
    formdata.append('sourceType', 'radiology')
    formdata.append('file', blobData, 'test_pdf.pdf')
    const requestOptions: RequestInit = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow',
    }

    const response = await fetch(
      radiologyIntents?.notificationUpload,
      requestOptions
    )

    if (response?.ok) {
      const result = await response.json()
      return result
    } else {
      return { fileId: '' }
    }
  } catch (error) {
    console.error(error)
  }
}

export const prepareRadiologyData = async (
  params: any,
  location: any,
  locations: any,
  radiologyDepartments: radiologyDepartments[],
  radiologyText: string,
  prefix: any,
  generatePDF: (data: any) => Promise<Blob>
): Promise<Blob | undefined> => {
  try {
    const item = params?.data
    const prefixIdentifier = location?.resource?.identifier?.find(
      (item: any) => item?.system === prefix
    )
    const locationAddress = getLocationAddress(
      prefixIdentifier?.value || '',
      locations
    )
    const refractored = item?.radiology_test_results?.map((e: any) => {
      const obj = {
        id: radiologyText,
        interpretation: e?.radiology_lab_test?.Interpretation ?? null,
        name: e?.test_name,
        sample: e?.sample_name,
        pathologyName: e?.authorised_by_name,
        pathologySignature:
          radiologyDepartments?.find((d) => d?.id === e?.authorised_by_id)
            ?.siganture || '',
        pathologistQualification:
          radiologyDepartments?.find((d) => d?.id === e?.authorised_by_id)
            ?.qualification || '',
        pathologyDepartment: 'radiology',
        resultType: 'observation',
        technician_name: e?.validated_by,
        tests: [e],
      }
      return { Radiology: [obj] }
    })
    const obj: any = {
      type: radiologyText,
      id:
        item?.patientUhid ?? item?.patientThopId ?? item?.patient_id ?? prefix,
      name: item?.patientName,
      age: item?.patientAge,
      gender: item?.patientGender,
      patientAddress: locationAddress,
      mobile: item?.patientMobile ?? '',
      lrNumber: item?.lr_number ?? '',
      radiologyTests: item?.radiology_order_tests,
      radiologyResults: refractored,
      orderType: item?.origin ?? '',
      orderedOn: item?.ordered_on ?? '',
      invoiceWithHeaderValue: false,
      requestedBy: item?.requested_by ?? item?.ordered_by_name ?? '',
      validatedOn: item?.validation_completed_on ?? '',
      fileId: item?.document_id,
    }
    const pdfBlob = await generatePDF(obj)
    return pdfBlob
  } catch (err) {
    console.error(err)
    toast?.error(collectionTable?.InoviceError)
    return undefined
  }
}
